<template>
  <main>
    <!-- Background -->
    <div class="big-background"></div>
    <!-- Step content -->
    <section class="container-full full-height flex pb-12 f-column align-items-center min-win-height">
      <!-- Step headline -->
      <h2 class="font-center width-9-768">Zadajte údaje pre overenie poistenia</h2>

      <div class="container-536 f-column mb-children-2">
        <!-- Service error -->
        <div class="snack-bar orange" v-if="errors.includes('FE001')">
          <div class="flex align-items-center">
            <em class="icon icon--info-white mr-1"></em>
            <p class="font-white">{{ errorMsg.FE001 }}</p>
          </div>
        </div>
        <!-- Service error -->
        <div class="snack-bar orange" v-if="errors.includes('FE003')">
          <div class="flex align-items-center">
            <em class="icon icon--info-white mr-1"></em>
            <p class="font-white">{{ errorMsg.FE003 }}</p>
          </div>
        </div>
        <!-- Service error -->
        <div class="snack-bar orange" v-if="errors.includes('FE005')">
          <div class="flex align-items-center">
            <em class="icon icon--info-white mr-1"></em>
            <p class="font-white">{{ errorMsg.FE005 }}</p>
          </div>
        </div>

        <!-- Inputs -->
        <div class="container-white mb-children-2">
          <!-- Contract number -->
          <div class="input-box-holder" v-has-value="contractNumber" v-validate="errors">
            <div class="input-box" ref="ContractNumber">
              <input v-model="contractNumber" id="contract-number" type="tel">
              <label for="contract-number">Číslo zmluvy</label>
              <tooltip>
                <h3 class="mb-2">Číslo zmluvy</h3>
                <p class="mb-2">
                  Zadajte číslo poistnej zmluvy, ku ktorej chcete zaslať fotografie pre účely obhliadky vozidla.
                </p>
              </tooltip>
            </div>
            <div class="validation-output">
              <div class="error" id="FE002">{{ errorMsg.FE002 }}</div>
            </div>
          </div>

          <!-- FO / PO -->
          <strong class="block mb-1 font-small">Poistník je:</strong>
          <radio-box v-model="personType"
            :options="[{ name$: 'PO', label: 'Právnicka osoba' }, { name$: 'FO', label: 'Fyzická osoba' }]"
            ref="RadioButtons"
          ></radio-box>

          <!-- Birth date -->
          <datepicker-box ref="BirthDate" v-model="birthDate" :value="birthDate" :errors="errors"
                          :class="{'hide':personType.name$ === 'PO'}" v-if="!model.isMobile">
            <label>Dátum narodenia</label>
            <template slot="tooltip">
              <h3 class="mb-2">Dátum narodenia</h3>
              <p class="mb-2">
                Zadajte dátum narodenia poistníka, uvedeného v poistnej zmluve.
              </p>
            </template>
            <template slot="validations">
              <div class="error" id="FE004">{{ errorMsg.FE004 }}</div>
            </template>
          </datepicker-box>

          <!-- Birth date Mobile -->
          <div class="input-box-holder" v-has-value="birthDate" v-validate="errors"
               :class="{'hide':personType.name$ === 'PO'}" v-if="model.isMobile">
            <div class="input-box">
              <input v-model="birthDate" ref="BirthDateMobile" id="birth-date-mobile" type="tel">
              <label for="birth-date-mobile">Dátum narodenia</label>
              <tooltip>
                <h3 class="mb-2">Dátum narodenia</h3>
                <p class="mb-2">
                  Zadajte dátum narodenia poistníka, uvedeného v poistnej zmluve.
                </p>
              </tooltip>
            </div>
            <div class="validation-output">
              <div class="error" id="FE004">{{ errorMsg.FE004 }}</div>
            </div>
          </div>

          <!-- Company number -->
          <div class="input-box-holder" v-has-value="companyNumber" v-validate="errors"
               :class="{'hide':personType.name$ === 'FO'}">
            <div class="input-box">
              <input v-model="companyNumber" ref="CompanyNumber" id="company-number" type="tel">
              <label for="company-number">IČO</label>
              <tooltip>
                <h3 class="mb-2">IČO</h3>
                <p class="mb-2">
                  Zadajte IČO spoločnosti, ktorá je uvedená ako poistník v poistnej zmluve.
                </p>
              </tooltip>
            </div>
            <div class="validation-output">
              <div class="error" id="FE006">{{ errorMsg.FE006 }}</div>
            </div>
          </div>

          <p>
            Informácie o ochrane osobných údajov nájdete
            <a
              href="https://www.union.sk/wp-content/uploads/2021/03/Zakladne-informacie-o-ochrane-osobnych-udajov_potencialni-klienti-klienti-alebo-osoba-opravnena-na-prijatie-poistneho-plnenia-1.pdf"
              target="_blank" class="font-red font-underline">
              tu</a>.
          </p>
        </div>

        <!-- CTA buttons -->
        <div
          id="cta-buttons-step-1"
          class="cta-buttons width-10 f-center mb-8 priority-1 first-step-cta"
        >
          <div class="width-10 width-9-768  f-center mr-children-2 justify-content-between-768 align-items-center-768">
            <button @click="submitData" v-scroll-to-error class="button-red continue">
              <div>Pokračovať</div>
              <em class="desktop-arrow ml-2 icon icon--arrow-right"></em>
              <em class="mobile-arrow icon icon--arrow-right-mobile" style="vertical-align: middle;"></em>
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- SEO content -->
    <div class="container-full pt-8 pb-12 background-white flex justify-content-center pt-3-768">
      <div class="container-560 pb-6 f-column mb-children-4">
        <h1 class="font-center mb-5 mb-3-768">Obhliadka vozidla cez webovú aplikáciu</h1>

        <p class="p-big-line-height">
          Ak si chcete auto poistiť proti krádeži, živlu alebo pre prípad havárie a vandalizmu, prípadne si uzavriete poistenie so zľavou za nízky nájazd kilometrov, je potrebná obhliadka
          auta alebo takzvaná samoobhliadka vozidla. Nikam nechodíte, na nikoho nečakáte, obhliadky vozidiel si vykonáte
          sami, zaslaním potrebných fotografií auta cez webovú aplikáciu.
        </p>

        <h2 class="mb-2">Obhliadka pri nových autách</h2>

        <p class="p-big-line-height">
          Ak si u nás chcete poistiť úplne nové auto, obhliadku vôbec neriešime. Obhliadku auta potrebujeme len pri
          ojazdených vozidlách.
        </p>
        <p class="p-big-line-height">
          Ak si uzatvoríte poistenie so zľavou za nízky nájazd kilometrov, obhliadku vyžadujeme vždy, aby sme mohli zaznamenávať, koľko kilometrov s autom ročne najazdíte.
        </p>

        <h2 class="mb-2">Obhliadka pri ojazdených autách</h2>

        <p class="p-big-line-height mb-1">Obhliadku motorového vozidla je potrebné vykonať v stanovenom termíne, ak je
          uzatvorené aspoň jedno z uvedených rizík: </p>

        <ul class="ml-2 font-gray mb-children-1">
          <li>havária
            a vandalizmus;
          </li>
          <li>živel;</li>
          <li>krádež;</li>
          <li>stret so zverou;</li>
          <li>pripoistenie skiel.</li>
        </ul>
        <h2 class="mb-2">Samoobhliadka vozidla cez našu webovú aplikáciu</h2>
        <p class="p-big-line-height">Vstupnú obhliadku auta si môžete vybaviť pohodlne aj sami. Uzatvorte si poistenie
          online alebo telefonicky, prejdite na našu webovú aplikáciu a postupujte podľa inštrukcií.</p>
        <h3 class="mb-2">Dôležité informácie o samoobhliadke:</h3>
        <ul class="ml-2 font-gray mb-children-1">
          <li>samoobhliadku je potrebné vykonať najskôr 3 dni pred a najneskôr 7 dní po začiatku poistenia;</li>
          <li>fotky auta sa cez webovú aplikáciu odošlú priamo k nám;</li>
          <li>po uložení fotiek v našom systéme vás budeme informovať, či sme fotky v poriadku prijali.</li>
        </ul>
      </div>
    </div>

    <!-- App footer -->
    <app-footer></app-footer>
  </main>
</template>

<script>
import { mapGetters } from 'vuex';
import { errorMsg } from '@/enums';

export default {
  name: 'Step1',
  data() {
    return {
      errorMsg,
      personType: { name$: 'PO', label: 'Právnicka osoba' },
    };
  },
  computed: {
    ...mapGetters({
      inspectionRequest: 'getInspection',
      errors: 'getErrors',
      inspectionResponse: 'getInspectionResponse',
      model: 'getModel',
    }),
    contractNumber: {
      get() {
        return this.$store.state.findInspection.contractNumber;
      },
      set(value) {
        this.$store.commit('SET_CONTRACTNUMBER', value);
        this.$store.dispatch('validateContractNumber');
      },
    },
    birthDate: {
      get() {
        if (!this.$store.state.findInspection.birthDate) {
          return null;
        }
        const birthDate = {
          year: this.$store.state.findInspection.birthDate.substr(0, 4),
          month: this.$store.state.findInspection.birthDate.substr(5, 2),
          day: this.$store.state.findInspection.birthDate.substr(8, 2),
        };
        if (this.model.isMobile) {
          if (this.errors.includes('FE004')) {
            return this.$store.state.findInspection.birthDate;
          }
          return `${birthDate.day}.${birthDate.month}.${birthDate.year}`;
        }
        return {
          year: parseInt(birthDate.year, 10),
          month: parseInt(birthDate.month, 10),
          day: parseInt(birthDate.day, 10),
        };
      },
      set(value) {
        const resetBirthDate = () => {
          this.$store.commit('SET_BIRTHDATE', null);
          this.$store.dispatch('validateBirthDate');
        };
        if (value === null) {
          resetBirthDate();
          return;
        }
        let dateString;
        if (value instanceof Object) {
          dateString = `${value.year}-${this.formatNumberForDate(value.month)}-${this.formatNumberForDate(value.day)}`;
          const testDate = new Date(dateString);
          if (testDate.toString() === 'Invalid Date') {
            resetBirthDate();
          }
        } else if (!/^\s*(3[01]|[12][0-9]|0?[1-9])\.(1[012]|0?[1-9])\.((?:19|20)\d{2})\s*$/.test(value)) {
          dateString = value;
        } else {
          const dateParts = value.split('.');
          dateString = `${this.formatNumberForDate(dateParts[2])}-${this.formatNumberForDate(dateParts[1])}-${this.formatNumberForDate(dateParts[0])}`;
        }

        this.$store.commit('SET_BIRTHDATE', dateString);
        this.$store.dispatch('validateBirthDate');
      },
    },
    companyNumber: {
      get() {
        return this.$store.state.findInspection.companyNumber;
      },
      set(value) {
        this.$store.commit('SET_COMPANYNUMBER', value);
        this.$store.dispatch('validateCompanyNumber');
      },
    },
  },
  watch: {
    companyNumber(value) {
      if (value === undefined) {
        this.personType = { name$: 'FO', label: 'Fyzická osoba' };
      } else {
        this.personType = { name$: 'PO', label: 'Právnicka osoba' };
      }
    },
  },
  methods: {
    formatNumberForDate(value) {
      const number = typeof value === 'string' ? parseInt(value, 10) : value;
      return number < 10 ? `0${number}` : number;
    },
    addFocusOut(el, key) {
      el.addEventListener('focusout', () => {
        this.$store.dispatch(`validate${key}`);
      });
    },
    async submitData() {
      this.$store.commit('SET_INSPECTIONRESPONSE', {});
      this.$store.commit('SET_ERRORS', []);
      this.$store.dispatch('validateStep');
      try {
        if (this.errors.length === 0) {
          await this.$store.dispatch('findInspection');
          this.$store.dispatch('validateStep');
          if (this.errors.length === 0) {
            this.$router.goToStep(2);
          }
        }
      } catch (e) {
        this.$store.dispatch('validateStep');
        this.$store.commit('SET_LOADING', false);
      }
    },
  },
  created() {
    this.$store.commit('SET_STEP', 1);
    this.$store.commit('SET_LASTSTEP', 1);
    if (this.inspectionRequest.companyNumber === undefined) {
      this.personType = { name$: 'FO', label: 'Fyzická osoba' };
    } else {
      this.personType = { name$: 'PO', label: 'Právnicka osoba' };
    }
  },
  mounted() {
    this.$refs.RadioButtons.$on('input', (value) => {
      if (value.name$ === 'PO') {
        this.$store.commit('SET_BIRTHDATE', undefined);
        if (typeof this.companyNumber !== 'string') {
          this.$store.commit('SET_COMPANYNUMBER', null);
        }
      }
      if (value.name$ === 'FO') {
        this.$store.commit('SET_COMPANYNUMBER', undefined);
        if (this.birthDate !== null && !this.birthDate.year) {
          this.$store.commit('SET_BIRTHDATE', null);
        }
      }
    });
    this.addFocusOut(this.$refs.ContractNumber, 'ContractNumber');
    this.addFocusOut(this.$refs.CompanyNumber, 'CompanyNumber');
    if (this.$refs.BirthDate) {
      this.addFocusOut(this.$refs.BirthDate.$el, 'BirthDate');
    }
    if (this.$refs.BirthDateMobile) {
      this.addFocusOut(this.$refs.BirthDateMobile.$el, 'BirthDate');
    }
  },
};
</script>

<style>

</style>
